import React from 'react';

const ConfirmModal = ({
    show,
    onClose,
    onConfirm,
    title = 'Are you sure?',
    message = 'Do you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel'
}) => {
   
    return (
        <div
            className={`modal fade ${show ? 'show d-block' : ''}`}
            tabIndex="-1"
            role="dialog"
            style={{
                // backgroundColor: show ? 'rgba(0,0,0,0.3)' : 'transparent',
                pointerEvents: show ? 'auto' : 'none',
                backdropFilter: 'blur(4px)'
            }}
        >
            <div className={`modal-dialog modal-dialog-centered ${show ? 'animate-slide' : ''}`} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <p>{message}</p>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                        >
                            {cancelText}
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={onConfirm}
                        >
                            {confirmText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
